import ICheckableGroup from '@inkline/inkline/src/components/ICheckableGroup';

export default {
    name: 'ICheckboxGroup',
    extends: ICheckableGroup
};
